<template>
  <v-main class="page-account page-account-leave">
    <AppBar :title="title" />
    <v-layout fill-height column>
      <v-container fluid>
        그동안 후유를 이용해주셔서 감사합니다.<br/>
        후유를 이용하시면서 불만족스러웠던 점을 지적해주시면 서비스 개선에 참고하겠습니다.
      </v-container>
      <v-container flex-fill fluid class="mt-2">
        <h3>회원탈퇴 확인사항</h3>
        <h4>1. 재가입하셔도 개인정보가 복원되지 않습니다.</h4>
        <p>후유에 가지고 계신 코인, 쿠폰등의 혜택이 모두 삭제되며 재가입하여도 복원되지 않습니다.</p>
        <h4>2. 아이디를 재 사용할 수 없습니다.</h4>
        <p>기존에 사용 하셨던 아이디는 재가입 시 사용할 수 없습니다.</p>
        <h4>3. 일부 정보는 법정 보유기간동안 보유됩니다.</h4>
        <p>
          전자상거래 등에서의 소비자 보호에 관한 법률 등 관련 법령의 규정에 의하여 일부 정보는 일정 기간동안 보유합니다.
          자세한 사항은 개인정보 수집·이용동의에서 확인하실 수 있습니다.
        </p>
      </v-container>
      <v-container fluid class="pb-0">
        <v-checkbox
            v-model="agree"
            :ripple="false"
            class="checkbox-circle"
        >
          <template #label>
            <div>
              위의 안내사항을 모두 확인 하였으며,<br/>탈퇴에 동의합니다.
            </div>
          </template>
        </v-checkbox>
      </v-container>
      <v-footer color="white" class="content-footer">
        <div class="content-buttons pt-0">
          <v-btn x-large block depressed
                 color="primary" class="btn-submit"
                 :disabled="!agree" @click="WithdrawalFlagOpen()">다음</v-btn>
        </div>
      </v-footer>
    </v-layout>
    <WithdrawalSheet ref="withdrawal" :title="title" :sheet="WithdrawalFlag" @sheetClose="WithdrawalFlag = false"
                       @rollerPickerOpen="rollerPickerOpen"/>
    <SelectRollerPicker ref="rollerPicker" @selectValue="selectValue"/>                 
  </v-main>
</template>

<script>

import WithdrawalSheet from "@/components/layout/bottomSheet/WithdrawalSheet"
import SelectRollerPicker from "@/components/layout/bottomSheet/SelectRollerPicker";
import {mixinAuth} from "@/mixins";
export default {
  name: 'Withdrawal',
  data: () => ({
    agree: false,
    WithdrawalFlag: false,
  }),
  mixins: [mixinAuth],
  components: {
    WithdrawalSheet,
    SelectRollerPicker,
  },
  computed: {
    title () {
      return this.memberGb === '01' ? '회원 탈퇴 요청' : '회원 탈퇴'
    }
  },
  methods: {
    rollerPickerOpen() {
      this.WithdrawalFlag = true
      this.$refs.rollerPicker.setFlicking(this.items);
    },
    selectValue(value) {
      this.$refs.withdrawal.selectValue(value);
    },
    WithdrawalFlagOpen() {
      this.WithdrawalFlag = true;
    },
  }
}
</script>
